var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59 59",
    style: {
      enableBackground: "new 0 0 59 59"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.5,51c0.6,0,1-0.4,1-1V17c0-0.6-0.4-1-1-1s-1,0.4-1,1v33C28.5,50.6,28.9,51,29.5,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,51c0.6,0,1-0.4,1-1V17c0-0.6-0.4-1-1-1s-1,0.4-1,1v33C18.5,50.6,18.9,51,19.5,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.5,51c0.6,0,1-0.4,1-1V17c0-0.6-0.4-1-1-1s-1,0.4-1,1v33C38.5,50.6,38.9,51,39.5,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.5,6h-14c-0.1-1.2-0.5-3.4-1.8-4.7C35.8,0.4,34.8,0,33.5,0h-10c-1.3,0-2.3,0.4-3.1,1.3 C19,2.6,18.7,4.8,18.5,6h-12c-0.6,0-1,0.4-1,1s0.4,1,1,1h2l1.9,46c0,1.7,1.1,5,4.9,5h28.3c3.8,0,4.9-3.3,4.9-5l1.9-46h2 c0.6,0,1-0.4,1-1S53.1,6,52.5,6z M21.8,2.7c0.4-0.5,1-0.7,1.7-0.7h10c0.7,0,1.3,0.2,1.7,0.7C36,3.5,36.3,5,36.4,6H20.6 C20.7,5,21,3.5,21.8,2.7z M46.5,54c0,0.3-0.1,3-2.9,3H15.4c-2.7,0-2.9-2.7-2.9-3L10.5,8h37.9L46.5,54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTrash);
export default __webpack_public_path__ + "static/media/icn-trash.b624848be4f8c5f7d8b1294aa2b1f447.svg";
export { ForwardRef as ReactComponent };